<template>
  <div class="certificate-query">
    <el-card>
      <template #header>
        <div class="card-header">
          <h2>证书查询</h2>
          <p>请选择查询方式查询您的证书信息</p>
        </div>
      </template>

      <!-- 查询方式切换 -->
      <el-radio-group v-model="queryType" class="query-type-group">
        <el-radio-button :label="1">姓名+手机号</el-radio-button>
        <el-radio-button :label="2">证书编号</el-radio-button>
      </el-radio-group>

      <!-- 查询表单 -->
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="large"
        class="query-form"
      >
        <template v-if="queryType === 1">
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入姓名"
              clearable
            />
          </el-form-item>
          
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入手机号"
              maxlength="11"
              clearable
            />
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item label="证书编号" prop="certificateNo">
            <el-input
              v-model="form.certificateNo"
              placeholder="请输入证书编号"
              clearable
            />
          </el-form-item>
        </template>

        <el-form-item>
          <el-button
            type="primary"
            :loading="querying"
            @click="handleQuery"
          >
            {{ querying ? '查询中...' : '查询' }}
          </el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 查询结果 -->
      <div v-if="certificates.length > 0" class="result-section">
        <el-divider content-position="left">
          <span class="result-title">查询结果（共{{ certificates.length }}条）</span>
        </el-divider>

        <el-row :gutter="20">
          <el-col
            v-for="cert in certificates"
            :key="cert.id"
            :xs="24"
            :sm="12"
            :md="8"
          >
            <el-card class="cert-card" shadow="hover">
              <div class="cert-info">
                <h3>{{ cert.cert_name }}</h3>
                <el-descriptions :column="1" size="small">
                  <el-descriptions-item label="证书编号">
                    {{ cert.cert_no }}
                  </el-descriptions-item>
                  <el-descriptions-item label="持证人">
                    {{ cert.holder_name }}
                  </el-descriptions-item>
                  <el-descriptions-item label="发证日期">
                    {{ cert.issue_date }}
                  </el-descriptions-item>
                  <el-descriptions-item label="有效期至">
                    {{ cert.expire_date || '长期有效' }}
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import certificateApi from '@/api/certificate'
import { mobileRule } from '@/utils/validate'

export default {
  name: 'CertificateQuery',
  
  data() {
    return {
      queryType: 1,
      form: {
        name: '',
        phone: '',
        certificateNo: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          mobileRule
        ],
        certificateNo: [
          { required: true, message: '请输入证书编号', trigger: 'blur' }
        ]
      },
      certificates: [],
      querying: false
    }
  },
  
  watch: {
    queryType() {
      this.handleReset()
    }
  },
  
  methods: {
    /**
     * 查询证书
     */
    async handleQuery() {
      const valid = await this.$refs.formRef.validate().catch(() => false)
      if (!valid) return
      
      this.querying = true
      
      try {
        let res
        
        if (this.queryType === 1) {
          res = await certificateApi.queryByNamePhone({
            name: this.form.name,
            phone: this.form.phone
          })
        } else {
          res = await certificateApi.queryByCertNo({
            cert_no: this.form.certificateNo
          })
        }
        
        if (res && res.code === 2000) {
          this.certificates = res.data || []
          
          if (this.certificates.length === 0) {
            this.$message.warning('未查询到相关证书信息')
          } else {
            this.$message.success(`查询成功，共找到${this.certificates.length}条记录`)
          }
        }
      } catch (error) {
        console.error('查询证书失败:', error)
      } finally {
        this.querying = false
      }
    },
    
    /**
     * 重置表单
     */
    handleReset() {
      this.$refs.formRef?.resetFields()
      this.certificates = []
    }
  }
}
</script>

<style lang="scss" scoped>
.certificate-query {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f7fa;
  
  .el-card {
    max-width: 1000px;
    margin: 0 auto;
    
    .card-header {
      text-align: center;
      
      h2 {
        margin: 0 0 10px 0;
        font-size: 24px;
        color: #303133;
      }
      
      p {
        margin: 0;
        color: #909399;
        font-size: 14px;
      }
    }
  }
  
  .query-type-group {
    display: flex;
    justify-content: center;
    margin: 30px 0;
  }
  
  .query-form {
    max-width: 500px;
    margin: 0 auto;
  }
  
  .result-section {
    margin-top: 40px;
    
    .result-title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }
    
    .cert-card {
      margin-bottom: 20px;
      
      .cert-info {
        h3 {
          margin: 0 0 15px 0;
          font-size: 18px;
          color: #303133;
          text-align: center;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .certificate-query {
    padding: 10px;
  }
}
</style>
